import React, { useMemo, useEffect, useState, forwardRef, useImperativeHandle } from 'react';

// BOOTSTRAP
import Row from '~/components/Bootstrap/Row';
import { ColSm12, ColSm2, ColSm3, ColSm4, ColSm6, ColSm8 } from '~/components/Bootstrap/Col';
import InputGroup from '~/components/Bootstrap/InputGroup';
import Label from '~/components/Bootstrap/Label';

// COMPONENTES GERAIS
import Modal, { ModalHeader } from "~/components/Modal";

// STYLED COMPONENTS
import { Main, Content, Footer } from "./styles";

// INPUTS
import InputNormal from '~/components/Inputs/Normal/Normal';
import TextareaNormal from '~/components/Textareas/Normal';
import SelectNormal from '~/components/Selects/Normal/Normal';

// BUTONS
import ButtonPrimary from '~/components/Buttons/Normal/Primary';
import ButtonSecondary from '~/components/Buttons/Normal/Secondary';
import ButtonDanger from '~/components/Buttons/Normal/Danger';

// UTILS
import numeral from '~/utils/numeral';
import Utils from '~/utils';
import NotificacaoUtil from '~/utils/notificacao';

// SERVICES
import WebsocketService, { WS_EVENT_UPDATED } from '~/services/websockets';
import APIRequests from "~/services/requests/painel";

const ModalBlock = forwardRef(
    ({
        onConfirm = () => { }
    }, ref) => {

        const [isVisible, setVisible] = useState(false);

        const [UUID, setUUID] = useState('');
        const [Serial, setSerial] = useState('');
        const [Emitente, setEmitente] = useState('');
        const [MotivoBloqueio, setMotivoBloqueio] = useState('');

        const onRequestConfirm = async () => {

            try {

                const retorno_api = await APIRequests.self_checkouts.bloquear(UUID,
                    {
                        motivo: MotivoBloqueio,
                    }
                );

                if (retorno_api?.id) {

                    NotificacaoUtil.success({
                        msg: `Self Checkout bloqueado com sucesso`,
                    });

                    // fecha o modal
                    onRequestClose();

                    // dispara a função externa
                    onConfirm();

                    /**
                     * Dispara a notificação.
                     */
                    WebsocketService.self_checkouts.emit(WS_EVENT_UPDATED, {
                        serial: Serial,
                    });

                } else {
                    NotificacaoUtil.error({
                        msg: `Erro ao bloquear o Self Checkout`,
                        timeout: 3500,
                    });
                }

            } catch (error) {
                NotificacaoUtil.error({
                    msg: error.message,
                    timeout: 3500,
                });
            }

        }

        const onRequestOpen = async (uuid = false) => {

            let visible = true;



            const dados = await APIRequests.self_checkouts.obter(uuid);

            if (dados.uuid) {

                setUUID(dados.uuid);
                setSerial(dados.serial);
                setEmitente(dados.emitente);

            } else {
                visible = false;
                new Noty({
                    type: 'error',
                    timeout: 2500,
                    text: 'Falha ao carregar os dados do Self Checkout.'
                }).show();
            }

            if (visible) {
                setVisible(visible);
            }

        }

        const onRequestClose = () => {
            setVisible(false);

            // reseta o estado
            setUUID('');
            setSerial('');
            setEmitente('');
            setMotivoBloqueio('');
        }

        const onKeyDown = (e) => {

            // pega o código pressionado
            const code = e.which !== false ? e.which : e.keyCode;

            // stop events
            if (code == 13 || code == 27) {
                e.preventDefault();
            }

            if (code == 13) {
                onRequestConfirm();
            }

            if (code == 27) {
                onRequestClose();
            }

        }

        /**
         * Passa a função de buscar para fora do input via ref.
         */
        useImperativeHandle(ref, () => (
            {
                open: onRequestOpen,
                close: onRequestClose
            }
        ));

        return (
            <Modal
                isVisible={isVisible}
                setVisible={onRequestClose}
                closeButtonVisible={false}
                closeOnClickOutside={false}
                width={420}
                height={385}
            >
                <Main>
                    <ModalHeader>
                        Bloquear Self Checkout
                    </ModalHeader>

                    <Content>

                        <Row>
                            <ColSm6>
                                <Label>Serial</Label>
                                <InputNormal
                                    disabled
                                    value={Serial}
                                />
                            </ColSm6>
                            <ColSm6>
                                <Label>Emitente</Label>
                                <InputNormal
                                    disabled
                                    value={Emitente}
                                />
                            </ColSm6>
                        </Row>

                        {/* <Row>
                            <ColSm12>
                                <Label>Data do bloqueio (futuro)</Label>
                                <InputNormal
                                    mask="cpf_cnpj"
                                    value={MotivoBloqueio}
                                    onKeyDown={onKeyDown}
                                    onChange={e => setMotivoBloqueio(e.target.value)}
                                />
                            </ColSm12>
                        </Row> */}

                        <Row>
                            <ColSm12>
                                <Label>Motivo do bloqueio</Label>
                                <TextareaNormal
                                    rows={5}
                                    value={MotivoBloqueio}
                                    onKeyDown={onKeyDown}
                                    onChange={e => setMotivoBloqueio(e.target.value)}
                                />
                            </ColSm12>
                        </Row>

                        <Footer>

                            <ButtonSecondary onClick={onRequestClose}>
                                Fechar
                            </ButtonSecondary>

                            <ButtonDanger onClick={onRequestConfirm}>
                                Bloquear
                            </ButtonDanger>

                        </Footer>

                    </Content>
                </Main>
            </Modal>
        )

    }
);

export default ModalBlock;